import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_3 = { class: "pic" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "bg" }

import { watch } from "vue";
import { useRouter, useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  product: Array,
  type: String,
},
  setup(__props) {

const props = __props;

const router = useRouter();
const route = useRoute();
for (const item of props.product) {
  item.animation = false;
  if (item.coverName) item.img = localStorage.getItem("fileUrel") + item.coverName;
}
watch(
  () => props.product,
  (newv, oldv) => {
    for (const item of props.product) {
      item.animation = false;
      if (item.coverName) item.img = localStorage.getItem("fileUrel") + item.coverName;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", item.animation ? 'in' : '']),
          key: index,
          onClick: ($event: any) => (_unref(router).push(`/website/product/details?id=${item.id}&&t=${__props.type}`)),
          onMouseenter: ($event: any) => (item.animation = true),
          onMouseleave: ($event: any) => (item.animation = false)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: item.img || '',
              alt: ""
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", null, _toDisplayString(item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(item.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "line" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(item.description), 1)
          ])
        ], 42, _hoisted_2))
      }), 128))
    ])
  ]))
}
}

})